import { Injectable, inject } from '@angular/core';
import {ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Subject} from 'rxjs';
import {Location} from '@angular/common';
import {Logger} from "../utils/logger";

@Injectable({
  providedIn: 'root'
})
export class IframeApiGuardService implements CanActivate {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private location = inject(Location);


  public loader$ = new Subject<boolean>();

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    Logger.log('canActivate IframeApiGuardService ', route)
    if(route.queryParams.pid && (route.queryParams.key || route.queryParams.token)){
      this.router.navigate([`app/p/${route.queryParams.pid}`], {queryParams: route.queryParams
      });
      return true;
    }
    return false;
  }

}
